export default "__VITE_ASSET__BOnpKacN__"